module.exports = __webpack_public_path__ + "img/weixin.b6c0a93e.png";